import React, { useId } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { TypedMemo } from '../../../common/types';
import { SongsBrewMark } from '../../../music24/artistHome/songsBrew/SongsBrewMark';
import { songsBrewMessages as messages } from '../../../music24/artistHome/songsBrew/songsBrewMessages';
import styles from './SongsBrewTickBox.module.scss';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/**
 * "Also send me SongsBrew" on the welcome (design: songsbrew-promotion b1-b5). The label wraps the
 * input, so the whole box is the hit area. Ticked: the soft brand fill. Under 720 px the small mark
 * goes (b4).
 */
const SongsBrewTickBoxComponent: React.FC<Props> = ({ checked, onChange, disabled = false }) => {
  const intl = useIntl();
  const hintId = useId();
  const inputId = useId();
  return (
    <label htmlFor={inputId} className={clsx(styles.tick, checked && styles.on, disabled && styles.disabled)}>
      <input
        id={inputId}
        type="checkbox"
        className={styles.input}
        checked={checked}
        disabled={disabled}
        aria-describedby={hintId}
        onChange={(event) => onChange(event.target.checked)}
        data-testid="songsbrew-welcome-tick"
      />
      <span className={styles.box} aria-hidden="true">
        <FontAwesomeIcon icon={faCheck} className={styles.check} />
      </span>
      <span className={styles.text}>
        <span className={styles.label}>{intl.formatMessage(messages.welcomeCheckbox)}</span>
        <span id={hintId} className={styles.hint}>
          {intl.formatMessage(messages.welcomeHint)}
        </span>
      </span>
      <SongsBrewMark size="xs" className={styles.mark} />
    </label>
  );
};

export const SongsBrewTickBox = TypedMemo(SongsBrewTickBoxComponent);
